import {
  focusFormatter,
  eventFormatter,
  paymentFormatter,
  logoutFormatter,
  userDetailsFilledFormatter,
  pageViewFormatter,
  formSubmitStatusFormatter,
  loginWithEmailFormatter,
  loginWithPhoneFormatter,
  userExtraDataFormatter,
  modalChangeFormatter,
  scrollFormatter,
  feedbackFormFormatter,
  submitFormatter,
  meetingBookmarkFormatter,
  trackUserFormatter,
  genericEventFormatter,
  leadFormAttributionFormatter,
} from '@tracking/components/events';
import { getGTMEventData } from '@tracking/components/transformer';
import {
  setContext, clearContext, removeContextKey, getContext,
} from '@tracking/components/context';
import {
  trackScrollHandler,
} from '@tracking/components/handlers/scroll';

export function setupEventTrackers() {
  // used internally
  window.GTMtracker = (function (window, dataLayer) {
    function pushToGTM(data) {
      if (!(window === window.parent) && data) {
        window.parent.postMessage(JSON.stringify(data), '*');
      } else {
        dataLayer?.push(data);
      }
    }

    function clearAttributes() {
      const data = { attributes: null };
      pushToGTM(data);
    }

    // this method adds already parsed GTM event object
    // into datalayer after injecting generic attributes
    function pushEvent(eventData) {
      if (eventData?.event) {
        const {
          event, action, data,
        } = eventData;
        const parsedEventData = getGTMEventData(
          event, action, data,
        );
        clearAttributes();
        pushToGTM(parsedEventData);
      }
    }

    function trackEvent(formatter, eventObj) {
      if (!formatter) {
        return;
      }
      if (window.GTMtracker[formatter]) {
        const data = window.GTMtracker[formatter](eventObj);
        if (Array.isArray(data)) {
          data.forEach((value) => {
            clearAttributes();
            pushToGTM(value);
          });
        } else {
          clearAttributes();
          pushToGTM(data);
        }
      }
    }

    return {
      trackEvent,
      pushEvent,
      pushToGTM,
      setContext,
      getContext,
      clearContext,
      removeContextKey,
      paymentFormatter,
      pageViewFormatter,
      logoutFormatter,
      userExtraDataFormatter,
      loginWithEmailFormatter,
      loginWithPhoneFormatter,
      userDetailsFilledFormatter,
      formSubmitStatusFormatter,
      focusFormatter,
      eventFormatter,
      modalChangeFormatter,
      feedbackFormFormatter,
      scrollFormatter,
      meetingBookmarkFormatter,
      submitFormatter,
      trackUserFormatter,
      genericEventFormatter,
      getGTMEventData,
      clearAttributes,
      leadFormAttributionFormatter,
    };
  }(window, window.dataLayer || []));

  // use this for tracking event
  window.TrackingHelper = {
    track: window.GTMtracker.trackEvent,
    clearAttributes: window.GTMtracker.clearAttributes,
    pushEvent: window.GTMtracker.pushEvent,
    setContext: window.GTMtracker.setContext,
    getContext: window.GTMtracker.getContext,
    clearContext: window.GTMtracker.clearContext,
    removeContextKey: window.GTMtracker.removeContextKey,
    scrollTracker: trackScrollHandler,
    pushToGTM: window.GTMtracker.pushToGTM,
  };
}
